import React, { useState } from "react";
import styles from "../StartingCustomPlan/DeskCustomPlan.module.css";
import StartNowBtn from "../../StartNowBtn/StartNowBtn";
import { planCards } from "../../../data/plans";
import createCheckoutUrl from "../../../lib/Store";
const DeskCustomPlan = ({ countryCode, pricingMap }) => {
  const [value, setValue] = useState(10);
  const [loading, setLoading] = useState(false);


  const min = 10;
  const max = 4000;

  const percentage = ((value - min) / (max - min)) * 100;

  // ⭐ LEFT SIDE: CALLS = minutes / 2.5
  const calls = Math.floor(value / 2.5);

  // ⭐ LEFT SIDE: PRICING MAP BASED
  const mappedPlans = pricingMap[countryCode] || pricingMap["USD"];
  const mappedCard = mappedPlans.find(
    (card) => value >= card.min && value <= card.max
  );

  const unit = mappedCard?.unit || 0;
  const flat = mappedCard?.flat || 0;

  const startingPrice = flat
    ? (flat + value * unit).toFixed(2)
    : (value * unit).toFixed(2);

  // ⭐ RIGHT SIDE: original static planCards logic
  const activeCard = planCards.find(
    (card) => value >= card.min && value <= card.max
  );
  // ⭐ IMPORTANT → Fade Out Condition
  const hideLeftContain = value >= 240;

  
  const handleStartNow = async () => {
    try {
      const response = await fetch(
        "https://srvr.rxpt.ai/api/tier/checkout/website",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            presetUnits: value,
            minUnits: min,
            maxUnits: max,
            // if you need to pass currency to backend, include it here
            currency: countryCode,
          }),
        }
      );

      const data = await response.json();
      if (data?.url) {
        window.open(data.url, "_blank");
      } else {
        alert("Something went wrong while creating the Stripe session.");
      }
    } catch (err) {
      console.error(err);
      alert("Error creating subscription: " + (err?.message || err));
    }
  };

  async function handleGetStarted(e, plan) {
    e?.stopPropagation?.();


    try {
      setLoading(true)
      const url = await createCheckoutUrl(plan, "month");
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Couldn't start checkout. Please try again.");
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        {/* ===================== LEFT SIDE (Dynamic Custom Plan) ===================== */}
        <div className={styles.LeftSection}>
          {/* TOP */}
          <div className={styles.Part1}>
            <div className={styles.TitleBar}>
              <h1 className={styles.title}>My Custom Plan</h1>

              <div className={styles.IconBar}>
                <div>
                  <img src="/Svg/custom-plan-icon.svg" alt="custom-plan-icon" />
                </div>

                <div className={styles.Calls}>
                  <p>Enough for</p>
                  <h3>{calls} CALLS.</h3>
                </div>
              </div>
            </div>

            {/* SLIDER */}
            <div className={styles.wrapper}>
              <div
                className={styles.tooltip}
                style={{ left: `calc(${percentage}% )` }}
              >
                {value} mins
              </div>

              <div className={styles.sliderContainer}>
                <input
                  type="range"
                  min={min}
                  max={max}
                  value={value}
                  onChange={(e) => setValue(Number(e.target.value))}
                  className={styles.slider}
                  style={{
                    background: `linear-gradient(to right, #6828F9 ${percentage}%, #ffffff ${percentage}%)`,
                  }}
                />
              </div>

              <div className={styles.rangeLabels}>
                <span>10 min</span>
                <span>4K min</span>
              </div>

              <p className={styles.helperText}>
                Select the number of <b>Minutes</b> your Business needs
              </p>
            </div>
          </div>

          {/* BOTTOM */}
          <div className={styles.Part2}>
            <div className={styles.StartingDiv}>
              <div
                className={`${styles.leftContain} ${hideLeftContain ? styles.hideLeft : ""
                  }`}
              >
                <p className={styles.starting}>STARTING</p>
                <h3 className={styles.just}>at just</h3>
              </div>

              <div className={styles.price}>
                <span className={styles.dollar}>$</span>
                <span className={styles.mainPrice}>
                  {String(startingPrice).split(".")[0]}
                </span>
                <span className={styles.decimal}>
                  .{String(startingPrice).split(".")[1] || "00"}
                </span>
              </div>
            </div>

            <div className={styles.features}>
              <p>Free VoIP #</p>
              <p>Chat & Call Widget</p>
              <p>Free 20 min * </p>
              <p>Built-In CRM</p>
              <p>+ Standard Feature</p>
            </div>

            <div className={styles.BtnDiv} onClick={() => handleStartNow(value, calls)} >
              <StartNowBtn />
            </div>
          </div>
        </div>

        {/* ===================== RIGHT SIDE (Original Active Card) ===================== */}
        <div className={styles.RightSection}>
          {!activeCard && (
            <div className={`${styles.card} ${styles.fadeIn}`}>
              <h2 className={styles.heading}>
                EXPLORE MORE <span>POWERFUL OPTIONS</span>
              </h2>

              <p className={styles.subText}>
                Unlock advanced AI features, unlimited calls, and priority
                support.
              </p>

              <button className={styles.btn}>Curated Packages</button>
            </div>
          )}

          {activeCard && (
            <div
              key={activeCard.title}
              className={`${styles.newStarterCard} ${styles.fadeSlideIn}`}
            >
              <div className={styles.HeaderPart}>
                <div>
                  <p className={styles.subTitle}>Perfect for a startup or micro business</p>
                  <h2 className={styles.planTitle} style={{ color: activeCard.colors?.title }} >{activeCard.title}</h2>
                </div>

                <div className={styles.msainPrice}>
                  <span className={styles.smallD}>
                    {activeCard?.pricing[countryCode]?.symbol ||
                      activeCard?.pricing.US.symbol}
                  </span>

                  <span className={styles.bigPrice}>
                    {activeCard?.pricing[countryCode]?.yearly ||
                      activeCard?.pricing.US.yearly}
                  </span>
                </div>
              </div>

              <p className={styles.billingText}>per month (Yearly billing)</p>

              <div className={styles.BottomBar}>
                <div className={styles.btnSide}>
                  <div className={styles.minutes} style={{ borderLeft: `16px solid ${activeCard.colors.minutesBorder}` }}>
                    <h1>{activeCard.minutes}</h1>
                    <p>minutes</p>
                  </div>

                  <button className={styles.startBtn} onClick={(e) => handleGetStarted(e, activeCard.title)}>{loading ? "Loading..." : "Get Started"}</button>
                </div>

                <div className={styles.featureList}>
                  {activeCard.features.map((f, i) => (
                    <p key={i} style={{
                      background: activeCard.colors?.featureBg,
                      color: activeCard.colors?.featureColor
                    }}>{f}</p>
                  ))}
                </div>
              </div>

              <img
                className={styles.betterOption}
                src={activeCard?.badgeImage}
                alt="better-option-price"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DeskCustomPlan;
